<template>
	<figure v-html="svg"></figure>
</template>

<script>
import iconosContorneados from '@/components/iconosContorneados'
import iconosSolidos from '@/components/iconosSolidos'

export default {
	name: 'VIcono',

	data: () => ({
		iconosContorneados: iconosContorneados,
		iconosSolidos: iconosSolidos
	}),

	props: {
		identificador: {
			type: String
		},
		estilo: {
			type: String,
			default: 'contorneado'
		},
		tamaño: {
			type: String,
			default: '1em'
		},
		value: {
			type: Object,
			default() {
				return {
					identificador: this.identificador || '',
					estilo: this.estilo
				}
			}
		}
	},

	computed: {
		svg: function() {
			let html = ''
			if (this.value && this.value.estilo === 'contorneado') {
				html = this.iconosContorneados.get(this.value.identificador)
			} else if (this.value && this.value.estilo === 'sólido') {
				html = this.iconosSolidos.get(this.value.identificador)
			}

			return (html || '').replace('<svg ', `<svg width="${this.tamaño}" height="${this.tamaño}" `)
		}
	},

}
</script>